// extracted by mini-css-extract-plugin
export default {"container":"style_container__yk3bs","dark":"style_dark__PWXAe"};